import React from 'react';
import Spinner from '../../components/loading-indicators/spinner';

const LoadingScreen = (): JSX.Element => {
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-main_screen_gray">
      <Spinner />
    </div>
  );
};

export default LoadingScreen;
